export default __webpack_public_path__ + "static/media/SE-marketing-page-3.6eb6bb0f.jpg";